import { api } from './api';

const searchBarsGetList = async (params) => {
    const response = await api({
        url: 'SearchBars/getByCustomerIdList',
        method: 'GET',
        params,
    });
    return response.data;
};

const customerVousList = async (data) => {
    const response = await api({
        url: 'CustomerVous/getList',
        method: 'GET',
        id:'CustomerVous-getList',
        params: data,
        cache: {
            ttl: 1000 * 60 * 60 * 8
        }
    });
    return response.data;
};

const searchBarVousOrderList = async (data) => {
    const response = await api({
        url: 'SearchBars/getSearchBarVousOrder',
        method: 'GET',
        params: data,
    });
    return response.data;
};

const searchBarVousOrderUpdate = async (data) => {
    const response = await api({
        url: 'SearchBars/updateSearchBarVousOrder',
        method: 'POST',
        data,
    });
    return response.data;
};

const searchBarsAdd = async (data) => {
    const response = await api({
        url: 'SearchBars/add',
        method: 'POST',
        data,
    });
    return response.data;
};

const searchBarsUpdate = async (data) => {
    const response = await api({
        url: 'SearchBars/update',
        method: 'PUT',
        data,
    });
    return response.data;
};

const searchBarsDelete = async (data) => {
    const response = await api({
        url: 'SearchBars/delete',
        method: 'DELETE',
        params: data,
    });
    return response.data;
};

const searchBarsServices = {
  searchBarsGetList,
  searchBarsAdd,
  searchBarsUpdate,
  searchBarsDelete,
  customerVousList,
  searchBarVousOrderList,
  searchBarVousOrderUpdate,
};

export default searchBarsServices;
